module.exports = __webpack_public_path__ + "img/sketch.8c160f7f.svg";